import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'


const _hoisted_1 = { class: "w-full pt-2 pb-4 px-4 h-full bg-gray-lp-1200" }
const _hoisted_2 = { class: "bg-white w-full h-full rounded-xl p-4" }
const _hoisted_3 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_CargoFilterSection = _resolveComponent("CargoFilterSection")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_CargoFilterSection, {
          ref: "filterSection",
          onOnChangeFilter: _ctx.onHandleFilter
        }, {
          actions: _withCtx(({ onDownload }) => [
            _createVNode(_component_lp_button, {
              onClick: ($event: any) => (onDownload(true)),
              title: "Download daftar gagal",
              outline: "",
              textColor: "red-lp-100",
              iconLeft: "download-new",
              sizeIcon: "14px"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["onOnChangeFilter"]),
        (_ctx.cargoListAvailable)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              customMessage: "Oops.. Belum ada data yang dapat ditampilkan"
            }))
          : (_openBlock(), _createBlock(_component_TableV2, {
              key: 1,
              columns: _ctx.columns,
              data: _ctx.cargoList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              paginationStyle: "v3",
              onRequest: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchCargoList('retry'))),
              errorCause: _ctx.errorCause,
              isDetailAble: _ctx.ableToViewDetail,
              isTabList: true,
              onClick: _ctx.onClickRow,
              isBorderOnHeadBgWhite: "",
              bgHeader: "bg-white border-t",
              paginationV3PaddingVertical: 'pt-1 pb-3',
              customClassPagination: 'absolute w-full bottom-2 right-0 left-0 -mb-4 px-8',
              isNoPaddingBottom: "",
              borderTop: false
            }, {
              origin_destination: _withCtx(({item}) => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.originCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.originCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ]),
                    _hoisted_5,
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.destinationCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  (item.cargoType === 'plane')
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportOriginCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _hoisted_7,
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportDestinationCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              atur_cancel_booking: _withCtx(({item}) => [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_lp_button, {
                    onClick: (e) => {
                e.stopPropagation()
                _ctx.handlerModalReBooking(true, item)
              },
                    title: "Booking ulang",
                    outline: "",
                    textColor: "red-lp-100"
                  }, null, 8, ["onClick"]),
                  _createVNode("img", {
                    class: "cursor-pointer",
                    src: _imports_0,
                    onClick: (e) => {
                e.stopPropagation()
                _ctx.handleDeleteCargoFromTable(item)
              }
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["columns", "data", "loading", "pagination", "errorCause", "isDetailAble", "onClick"]))
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
      [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.deleteCargo(),
      onClose: () => _ctx.handlerModalDeleteBooking(false, []),
      title: "Hapus nomor booking?",
      message: `<b>Nomor Booking “${_ctx.cargoColumnData(_ctx.tempDataReBooking.bookingRequestId, _ctx.tempDataReBooking.cargoNumber)}”</b> akan hilang & terhapus dari tabel cargo.`,
      image: "badge-confirmation-general",
      textSuccess: "Ya, Hapus",
      textCancel: "Batalkan",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showModalDeleteBooking]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.goToReBooking(),
      onClose: () => _ctx.handlerModalReBooking(false, []),
      title: "Booking ulang?",
      message: `Apakah anda yakin ingin booking ulang <b>No. Booking “${_ctx.cargoColumnData(_ctx.tempDataReBooking.bookingRequestId, _ctx.tempDataReBooking.cargoNumber)}”</b>?`,
      image: "badge-confirmation-general",
      textSuccess: "Ya, Booking ulang",
      textCancel: "Batalkan",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showModalReBooking]
    ])
  ], 64))
}